import { OtherSteps } from '../enums';

export const nonComplaintSteps = [OtherSteps.Plan, OtherSteps.Soap];
